import { useParams } from 'react-router-dom';

import { useQuery } from '@tanstack/react-query';

import { EQueryKeys } from '../constants/enums';
import useAxios from '../hooks/useAxios';

import {
  EApiRoutes,
  fetchConfig,
  getApiRouteOrMock,
  getCustomHeader
} from './api.utils';

export default function useRoles() {
  const axios = useAxios();
  const { publisherId, portalId } = useParams();

  const getRoles = useQuery<any, Error>({
    retry: false,
    queryKey: [EQueryKeys.ROLES],
    queryFn: async () => {
      return await axios.get(
        `${getApiRouteOrMock(EApiRoutes.ROLES)}`,
        {},
        getCustomHeader(publisherId, portalId)
      );
    }
  });

  return {
    getRoles
  };
}
